(function (root) {
  'use strict';
  function offerFor(config, pack, variantId) {
    var offer = config.packs[String(pack)];
    if (!offer) return null;
    var selected = (config.variants || []).find(function (variant) { return String(variant.id) === String(variantId); });
    var source = offer.useSelected && selected ? selected : offer;
    return {
      id: Number(source.id),
      price: Number(source.price) * offer.units,
      compare: Number(source.compare_at_price || source.compare || 0) * offer.units,
      quantity: offer.units,
      available: Boolean(source.available) && Number(source.id) > 0
    };
  }
  function selectedTotal(offer, extras) {
    return (offer ? offer.price : 0) + extras.reduce(function (sum, extra) { return sum + Number(extra.price); }, 0);
  }
  function buildItems(offer, extras) {
    if (!offer || !offer.available) throw new Error('Unavailable product');
    var items = [{ id: offer.id, quantity: offer.quantity }];
    extras.forEach(function (extra) {
      if (!extra.id || !Number.isFinite(Number(extra.price))) throw new Error('Unavailable add-on');
      items.push({ id: Number(extra.id), quantity: 1 });
    });
    return items;
  }
  var api = Object.freeze({ offerFor: offerFor, selectedTotal: selectedTotal, buildItems: buildItems });
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.PawCommerce = api;
})(typeof window === 'undefined' ? globalThis : window);
